import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { environment } from "@environments/environment";
import { Certificate } from "@interfaces/certificate";

@Injectable({
  providedIn: "root"
})
export class CertificateService {
  baseUrl = `${environment.api.mv.nf}/empresa/certificado`;

  constructor(private readonly httpService: HttpService) {}

  upload(data: FormData) {
    return this.httpService.post<{
      id: string;
      nome: string;
      hash: string;
      vencimento: string;
      cnpj: string;
    }>(this.baseUrl, data);
  }

  validate(data: FormData) {
    return this.httpService.post<{
      valido: boolean;
      vencido: boolean | null;
      vigenciaInicio: string | null;
      vigenciaFim: string | null;
      diasParaVencer: number | null;
      mensagem: string;
    }>(`${this.baseUrl}/validar`, data);
  }

  fetch(id: string) {
    return this.httpService.get<Certificate>(`${this.baseUrl}/${id}`);
  }
}
